import i18n from '@src/common/lib/i18n'
import utils from '@src/common/utils'
export const personTableOption = function () {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: false,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewFormSlot: false,
    labelSuffix: '：',
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    labelPosition: 'right',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 350,
    dialogWidth: '640px',
    emptyText: '暂无数据',
    menu: false,
    column: [{
        label: '照片',
        prop: 'imageUrl',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        align: 'center',
      },
      {
        label: '访客姓名',
        prop: 'personName',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
      },
      {
        label: '性别',
        prop: 'personSex',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
      },
      {
        label: '手机号码',
        prop: 'personPhone',
        search: false,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: true,
        editDisabled: false,
        overHidden: true,
        hide: false,
        align: 'center',
      },
      
      {
        label: '身份证号',
        prop: 'idCardNo',
        search: false,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        align: 'right',
        hide: false,
        span: 24
      },
      {
        label: '车牌号码',
        prop: 'plateNumber',
        search: true,
        overHidden: true,
        addDisplay: false,
        editDisplay: false,
        viewDisplay: false,
        align: 'right',
        hide: false,
        span: 24,
        
      }
    ]
  }
}